import React from "react";
import classes from "./input.module.css";
const Input = ({
  extraClass,
  name,
  value,
  placeholder,
  type,
  onChange,
  HolderClass,
  err,
  disabled,
  errMsg,
  onBlur,
}) => {
  if (extraClass === undefined) extraClass = [];
  return (
    <div className={[classes.inputHolder, HolderClass].join(" ")}>
      <input
        onBlur={onBlur}
        className={[classes.input, ...extraClass].join(" ")}
        placeholder={placeholder}
        type={type}
        name={name}
        disabled={disabled}
        value={value}
        onChange={onChange}
      ></input>
      {err ? (
        <span className={classes.err}>{errMsg}</span>
      ) : (
        <span className={classes.err} style={{ visibility: "hidden" }}>
          {errMsg}
        </span>
      )}
    </div>
  );
};

export default Input;
